import { createAsyncThunk } from '@reduxjs/toolkit';
import { getNotifications } from '../../services/notification';

export const getNotificationList = createAsyncThunk(
    'notification',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getNotifications(token.token);
        
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        console.log(err.response.data.error)        
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch events');
      }
    }
  );